import { makeStyles } from '@material-ui/core';
import { Form, Formik } from 'formik';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { PropTypes } from 'prop-types';
import LanguageContext from '../../../contexts/languageContext';
import MessagesContext from '../../../contexts/messagesContext';
import { getNamespace } from '../../../utils/storage';
import { ClinicInput, SubmitButton } from '../../UI';
import { createClinic, updateClinic } from '../../../redux/Clinic/ClinicAction';

const styles = makeStyles({
    container: {
        minWidth: '400px',
        padding: '20px'
    },
    inputContainer: {
        '& input': {
            width: '190px'
        }
    },
    submitBtnContainer: (props) => ({
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'absolute',
        bottom: '17px',
        left: props.rtl ? '10px' : 'auto',
        right: props.rtl ? 'auto' : '10px',
        margin: '0 10px'
    })
});
const ClinicForm = ({ clinic, isEditing = false, handleClose }) => {
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const today = new Date();
    const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();

    const dispatch = useDispatch();

    return (
        <Formik
            enableReinitialize
            initialValues={{ name: clinic?.name || '' }}
            validationSchema={Yup.object({
                name: Yup.string().required(messages.validations.required)
            })}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                const body = {
                    namespace: getNamespace(),
                    name: values.name,
                    start_time: clinic?.start_time || time,
                    start_tz: 'Asia/Tehran'
                };

                const response = await dispatch(
                    isEditing ? updateClinic(clinic?.id, body) : createClinic(body)
                );

                setSubmitting(false);
                if (response?.status === 201 || response?.status === 200) {
                    handleClose();
                }
            }}
        >
            {({ isSubmitting, values }) => (
                <Form>
                    <div className={classes.container}>
                        <div className={classes.inputContainer}>
                            <ClinicInput
                                name="name"
                                label={messages.clinicName}
                                value={values.name}
                                type="text"
                                dir="auto"
                                autoFocus
                            />
                        </div>

                        <div className={classes.submitBtnContainer}>
                            <SubmitButton
                                data-testid="submitBtn"
                                isSubmitting={isSubmitting}
                                submitText={isEditing ? messages.editClinic : messages.submitClinic}
                            />
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};
ClinicForm.propTypes = {
    clinic: PropTypes.object,
    isEditing: PropTypes.bool,
    handleClose: PropTypes.function
};

export default ClinicForm;
